export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-6 md:px-10">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="text-2xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950">
            Готовы начать шоппинг?
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-500">
            Переходите на основной сайт для оформления заказа через YOYbuy Sheet
          </p>
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-foreground-900 text-background-50 hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
            >
              yoybuy sheet
              <i className="ri-arrow-right-up-line"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-8 py-3.5 text-sm font-semibold rounded-full bg-accent-500 text-white hover:bg-accent-600 transition-all whitespace-nowrap cursor-pointer"
            >
              buy it now
              <i className="ri-arrow-right-up-line"></i>
            </a>
          </div>
        </div>
      </div>

      <div className="mt-14 md:mt-20 w-full overflow-hidden">
        <div className="flex gap-0">
          <img
            src="https://readdy.ai/api/search-image?query=A%20stylish%20white%20leather%20sneaker%20isolated%20on%20transparent%20background%20clean%20product%20photography%20with%20soft%20natural%20lighting%20minimal%20aesthetic%20high%20detail%20professional%20ecommerce%20style&width=300&height=300&seq=yoybuy-cta-item-01&orientation=squarish"
            alt=""
            className="w-[200px] md:w-[260px] h-[200px] md:h-[260px] object-cover object-top"
          />
          <img
            src="https://readdy.ai/api/search-image?query=A%20casual%20light%20beige%20hoodie%20isolated%20on%20white%20background%20clean%20product%20photography%20soft%20natural%20lighting%20minimal%20ecommerce%20style%20professional%20catalog%20shot&width=300&height=300&seq=yoybuy-cta-item-02&orientation=squarish"
            alt=""
            className="w-[200px] md:w-[260px] h-[200px] md:h-[260px] object-cover object-top"
          />
          <img
            src="https://readdy.ai/api/search-image?query=A%20classic%20white%20cotton%20t-shirt%20isolated%20on%20white%20background%20clean%20minimal%20product%20photography%20soft%20natural%20lighting%20professional%20ecommerce%20style&width=300&height=300&seq=yoybuy-cta-item-03&orientation=squarish"
            alt=""
            className="w-[200px] md:w-[260px] h-[200px] md:h-[260px] object-cover object-top"
          />
          <img
            src="https://readdy.ai/api/search-image?query=A%20modern%20minimal%20black%20backpack%20isolated%20on%20white%20background%20clean%20product%20photography%20soft%20natural%20lighting%20professional%20ecommerce%20style&width=300&height=300&seq=yoybuy-cta-item-04&orientation=squarish"
            alt=""
            className="w-[200px] md:w-[260px] h-[200px] md:h-[260px] object-cover object-top"
          />
          <img
            src="https://readdy.ai/api/search-image?query=A%20pair%20of%20classic%20round%20sunglasses%20isolated%20on%20white%20background%20clean%20minimal%20product%20photography%20soft%20natural%20lighting%20professional%20ecommerce%20style&width=300&height=300&seq=yoybuy-cta-item-05&orientation=squarish"
            alt=""
            className="w-[200px] md:w-[260px] h-[200px] md:h-[260px] object-cover object-top"
          />
        </div>
      </div>
    </section>
  );
}